module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcement_create_icon_disabled.532abd8f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/images/announcement_create_icon_disabled.png
// module id = 2883
// module chunks = 11